// extracted by mini-css-extract-plugin
export default {"oauthButtonContainer":"OAuth2Button_oauthButtonContainer__P0dJy","oauthPopupContainer":"OAuth2Button_oauthPopupContainer__CxbSM"};